// extracted by mini-css-extract-plugin
module.exports = {"container":"e_pr","anchor":"e_qr"};